module.exports = __webpack_public_path__ + "static/media/drive.b4ddee55.png";